import { useContext, useState } from 'react';

import AdminModal from '../../reusable/admin-modal/admin-modal.component';
import Button from '../../reusable/button/button.component';
import Spinner from '../../reusable/spinner/spinner.component';

import { ToastContext } from '../../../contexts/toast.context';

import {
  MainContainer,
  FieldGroup,
  FieldLabel,
  UpdateNoteInput,
  UpdateNoteTextarea,
  UpdateNoteSelect,
  ButtonContainer
} from './update-note.styles';

const UpdateNote = ({ note, onUpdate, onDelete, onClose }) => {
  const [content, setContent] = useState(note.content);
  const [type, setType] = useState(note.type || '');
  const [isPublic, setIsPublic] = useState(note.isPublic || false);
  const [metadata, setMetadata] = useState(note.metadata || '');

  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const { errorToast } = useContext(ToastContext);

  const confirmDelete = () => setShowDeleteModal(true);

  const submitUpdate = async () => {
    if (!content.trim()) {
      errorToast('Note content is required.');
      return;
    }

    setLoading(true);

    const updatedData = {
      content,
      type,
      isPublic,
      metadata
    };

    await onUpdate(note.id, updatedData);
    setLoading(false);
  };

  return (
    <MainContainer>
      <AdminModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        title={'Delete Note'}
        message={`Are you sure you want to delete this note?`}
        action={() => onDelete(note.id)}
        actionText="Delete"
      />

      {loading ? (
        <Spinner />
      ) : (
        <>
          <h2>Edit Note</h2>

          <FieldGroup>
            <FieldLabel htmlFor="note-content">Content</FieldLabel>
            <UpdateNoteTextarea
              id="note-content"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Edit note content"
            />
          </FieldGroup>

          <FieldGroup>
            <FieldLabel htmlFor="note-type">Type</FieldLabel>
            <UpdateNoteInput
              id="note-type"
              value={type}
              onChange={(e) => setType(e.target.value)}
              placeholder="Optional type (e.g. admin, issue)"
            />
          </FieldGroup>

          {/* <FieldGroup>
            <FieldLabel htmlFor="note-metadata">Metadata</FieldLabel>
            <UpdateNoteTextarea
              id="note-metadata"
              value={metadata}
              onChange={(e) => setMetadata(e.target.value)}
              placeholder="Optional metadata (string or JSON)"
            />
          </FieldGroup> */}

          <FieldGroup>
            <FieldLabel htmlFor="note-public">Visibility</FieldLabel>
            <UpdateNoteSelect
              id="note-public"
              value={isPublic}
              onChange={(e) => setIsPublic(e.target.value === 'true')}
            >
              <option value="true">Public</option>
              <option value="false">Internal Only</option>
            </UpdateNoteSelect>
          </FieldGroup>

          <h4>{isPublic ? 'Public' : 'Internal Only'}</h4>

          <Button onClick={confirmDelete}>Delete</Button>

          <ButtonContainer>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={submitUpdate}>Update</Button>
          </ButtonContainer>
        </>
      )}
    </MainContainer>
  );
};

export default UpdateNote;